import '@pp/core/src/utils/setDynamicPublicPath';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@pp/core/src/styles/core.css';

import { GtagLogger } from '@pp/core/src/logger/GtagLogger';

import { Game } from './Game';

import './styles/main.css';

try {
  GtagLogger.logEvent('game-load-started', undefined);
  performance.mark('loadStartForGtag');
} catch (e) {
  //
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Game />
  </StrictMode>
);
